import { Component, OnInit } from '@angular/core';
import { configureAmplify } from '../../config/aws.config';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RegistrationService } from '../../services/registration.service';
import { AWSCognitoErrorResponse } from '../../models/error.model';

@Component({
  selector: 'online-app-agent-auth',
  templateUrl: './agent-auth.component.html',
  styleUrls: ['./agent-auth.component.scss']
})
export class AgentAuthComponent implements OnInit {

  agentRegistrationConfirmationSuccessful = false;
  errorMessage: string;
  userAlreadyConfirmed = false;

  constructor(private authService: AuthService,
              private router: Router,
              private registrationService: RegistrationService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    configureAmplify(false);

    const username = this.activatedRoute.snapshot.queryParamMap.get('username');

    const tempPassword = this.activatedRoute.snapshot.queryParamMap.get('tempPassword');
    //console.log(`username: ${username}, tempPassword:${tempPassword}`);

    if (username && tempPassword) {

      this.authService.agentLogin(username, tempPassword)
          .subscribe( user => {

            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
              //console.log('got challenge NEW_PASSWORD_REQUIRED');
            }

          });



    }

  }
}
